const UserType = Object.freeze({
  ORIOLA: "ORIOLA",
  CUSTOMER: "CUSTOMER",
  PRINCIPAL: "PRINCIPAL",
});

export default UserType;
